import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function FloatingActionButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Mostrar el botón después de hacer scroll mayor a 200px
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // No mostrar el botón en el Dashboard (tiene barra rápida) ni en nuevo pedido
  if (location.pathname === '/' || location.pathname === '/nuevo-pedido') {
    return null;
  }

  const handleClick = () => {
    navigate('/nuevo-pedido');
    // Hacer scroll hacia arriba al navegar
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`fab ${isVisible ? 'fab-visible' : ''}`}
      onClick={handleClick}
      aria-label="Nuevo pedido de oración"
    >
      <span className="fab-icon">+</span>
    </button>
  );
}

export default FloatingActionButton;
